import {Presentation} from "../../../../../core/gameflow/controller/Presentation";
import {PREngineManager} from "../../../../punkEngine/PREngineManager";
import {PunkRocker} from "../../../../PunkRocker";
import {GameData} from "../../../../server/data/GameData";

export class CapWinPresentation extends Presentation {

    protected _state:string = "Post";
    private _hasCountUp:boolean = false;
    private _isPlaying:boolean = false;

    initialization(): void {
    }

    public setGamedData(data: GameData): void {
        this._hasCountUp = data.Win.singleWin>0;
        this._isPlaying = false;
        PunkRocker.capWinView.setGamedData(data);
    }

    public checkForActivation(data: GameData): boolean {
      return data.raw.brokeTheBank;
    }

    preStart(): void {
    }

    createPresentation(quickStop:Function){
        quickStop(false);
        if(PunkRocker.counter.timeRemaining){
            this.timeline.to(this,{duration:PunkRocker.counter.timeRemaining})
        }
        switch(this._state){
            case "Post":
                this.post();
                this._state = "Done";
                break
            default:
                if(!this._isPlaying){
                    this._isPlaying = true;
                    this.playWinAnimation();
                }

                break;
        }
    }

    public post(): void {
            this.timeline.to(this, {duration: this._hasCountUp?1:0.1});
    }
    public playWinAnimation(): void {
        this.timeline.add(PunkRocker.capWinView.show(()=>{
            this.PresentationState.setInactive();
        }), 0);

    }

    public done(): void {
        PREngineManager.RSAll((rc, sym) => sym.markNonWin(false));
    }

}